import { useState } from "react";
import { createOrEditAdmin } from "../../utils/wellspoken.api";
import toast from "react-hot-toast";

const NewAdmin = () => {
  const [formData, setFormData] = useState({
    Name: "",
    Email: "",
    Mobile: "",
    Password: "",
    IsActive: true,
    IsApproval: true,
    EntityId: 1,
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess("");
    setError("");

    // Prepare the exact payload your cURL expects
    const payload = {
      UserId: 0, // ✅ Required by backend (Identity column usually expects 0)
      Name: formData.Name,
      Email: formData.Email,
      Mobile: formData.Mobile,
      Password: formData.Password,
      IsActive: formData.IsActive,     // using default state
      IsApproval: formData.IsApproval, // using default state
      EntityId: Number(formData.EntityId) // ✅ Ensure this is a number, not string
    };

    try {
      await createOrEditAdmin(payload); // Send the constructed payload
      toast.success("Admin created successfully!")

      // Reset form (keep your default hidden values)
      setFormData({
        Name: "",
        Email: "",
        Mobile: "",
        Password: "",
        IsActive: true,
        IsApproval: true,
        EntityId: 1,
      });
    } catch (err) {
      console.error(err);
      // Display the actual error message if your API throws one
      setError(err.message || "Failed to create admin. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main
      className="min-h-screen w-full
             bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50
             px-4 sm:px-6 lg:px-10"
    >
      {/* Header */}
      <section
        className="w-full text-center mb-8"
        aria-labelledby="create-admin-heading"
      >
        <h1
          id="create-admin-heading"
          className="text-3xl sm:text-4xl font-bold text-gray-900"
        >
          Create Admin
        </h1>
        <p className="mt-2 text-gray-600 max-w-2xl mx-auto">
          Fill the details below to create a new admin account.
        </p>
      </section>

      {/* Form Card – FULL WIDTH */}
      <section
        className="w-full
               bg-white/95 backdrop-blur-xl
               rounded-2xl shadow-lg
               p-6 sm:p-8 lg:p-10"
        aria-label="Create admin form section"
      >
        <form
          onSubmit={handleSubmit}
          className="space-y-6"
          aria-label="Create Admin Form"
        >
          {/* Name */}
          <div>
            <label
              htmlFor="Name"
              className="block text-sm font-medium text-gray-700"
            >
              Full Name
            </label>
            <input
              type="text"
              id="Name"
              name="Name"
              value={formData.Name}
              onChange={handleChange}
              required
              placeholder="John Kumar"
              className="mt-2 w-full rounded-lg border border-gray-300
                     bg-white px-4 py-2.5 text-gray-900
                     transition
                     focus:border-blue-500
                     focus:ring-2 focus:ring-blue-500/30"
            />
          </div>

          {/* Email */}
          <div>
            <label
              htmlFor="Email"
              className="block text-sm font-medium text-gray-700"
            >
              Email Address
            </label>
            <input
              type="email"
              id="Email"
              name="Email"
              value={formData.Email}
              onChange={handleChange}
              required
              placeholder="john@gmail.com"
              className="mt-2 w-full rounded-lg border border-gray-300
                     bg-white px-4 py-2.5 text-gray-900
                     transition
                     focus:border-indigo-500
                     focus:ring-2 focus:ring-indigo-500/30"
            />
          </div>

          {/* Mobile */}
          <div>
            <label
              htmlFor="Mobile"
              className="block text-sm font-medium text-gray-700"
            >
              Mobile Number
            </label>
            <input
              type="tel"
              id="Mobile"
              name="Mobile"
              value={formData.Mobile}
              onChange={handleChange}
              required
              placeholder="+91 XXXXXXXX"
              className="mt-2 w-full rounded-lg border border-gray-300
                     bg-white px-4 py-2.5 text-gray-900
                     transition
                     focus:border-blue-500
                     focus:ring-2 focus:ring-blue-500/30"
            />
          </div>

          {/* Password */}
          <div>
            <label
              htmlFor="Password"
              className="block text-sm font-medium text-gray-700"
            >
              Password
            </label>
            <input
              type="password"
              id="Password"
              name="Password"
              value={formData.Password}
              onChange={handleChange}
              required
              className="mt-2 w-full rounded-lg border border-gray-300
                     bg-white px-4 py-2.5 text-gray-900
                     transition
                     focus:border-indigo-500
                     focus:ring-2 focus:ring-indigo-500/30"
            />
          </div>

          {/* Submit */}
          <button
            type="submit"
            disabled={loading}
            className="w-full sm:w-auto rounded-xl
                   bg-gradient-to-r from-blue-600 to-indigo-600
                   px-8 py-3 text-white font-semibold
                   hover:from-blue-500 hover:to-indigo-500
                   focus-visible:outline-none
                   focus-visible:ring-2 focus-visible:ring-blue-500/40
                   disabled:opacity-60 transition"
          >
            {loading ? "Creating..." : "Create Admin"}
          </button>

          {/* Success / Error */}
          {success && (
            <p className="text-green-600 text-sm font-medium mt-2">
              {success}
            </p>
          )}
          {error && (
            <p className="text-red-500 text-sm font-medium mt-2">
              {error}
            </p>
          )}
        </form>
      </section>
    </main>

  );
}

export default NewAdmin;
